export const baseFetch = async (
  urlPath: string,
  options: RequestInit,
): Promise<Response> => {
  const defaultOptions: RequestInit = {
    credentials: 'include' as RequestCredentials,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const finalOptions: RequestInit = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    } as HeadersInit,
  };

  return await fetch(urlPath, { ...finalOptions });
};
